export default __webpack_public_path__ + "static/media/horse.16d3ab60.png";